import ReactDOM from 'react-dom'
import GroupName from 'components/GroupName'

export default () => ({
  scope: { group: '=evaGroupName' },
  link({ group }, $element) {
    ReactDOM.render(<GroupName group={group} />, $element[0]);
  }
});
